<template>
  <div>
    <el-row :gutter="12" class="mt-2" v-loading.fullscreen.lock="customersNew.isLoading">
      <el-row type="flex" justify="space-between" align="middle" class="mb-4">
        <p class="category-title ma-0">Customer New</p>

        <el-col :span="16">
          <el-row type="flex" justify="end">
            <el-select
              v-model="optionView"
              size="small"
              placeholder="Select"
              class="mr-2"
              @change="
            e => {
              toAnotherPage(page, e, form.search, valueStatus), settingTable(page, e);
            }
          "
              style="width: 100px"
            >
              <el-option
                v-for="item in optionsView"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>

            <el-input
              size="small"
              v-model="form.search"
              placeholder="Search by retur id or customer name"
              style="width: 200px"
              class="mr-2"
              @keyup.enter.native="onSearch"
            ></el-input>
          </el-row>
        </el-col>
      </el-row>

      <el-col :span="24">
        <el-table empty-text="Tidak ada data" :data="customersNew.data" style="width: 100%">
          <el-table-column sortable prop="company_name" label="Company/Outlate Name" width="280"></el-table-column>
          <el-table-column sortable prop="owner" label="Owner" width="180"></el-table-column>
          <el-table-column sortable prop="status" label="Status" width="180"></el-table-column>
          <el-table-column sortable prop="bussines_entity" label="Bussines Entity" width="180"></el-table-column>
          <el-table-column sortable prop="nik" label="NIK" width="180"></el-table-column>
          <el-table-column sortable prop="npwp" label="NPWP" width="180"></el-table-column>
          <el-table-column sortable prop="tlp" label="Tlp. No" width="180"></el-table-column>
          <el-table-column sortable prop="email_address" label="Email Address" width="180"></el-table-column>
          <el-table-column sortable prop="ship_to" label="Ship To" width="180"></el-table-column>
          <el-table-column sortable prop="bill_to" label="Bill To" width="180"></el-table-column>
          <el-table-column fixed="right" align="center" label="Operations" width="100">
            <template slot-scope="scope">
              <el-button
                type="warning"
                size="mini"
                icon="el-icon-edit"
                circle
                @click="() => {dialogFormVisible = true, payload = {
                  id: scope.row.id,
                  status: scope.row.status,
                  idx: scope.row.idx
                }}"
              ></el-button>
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-view"
                circle
                @click="$router.push(`/customer-new/edit/${scope.row.id}`)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end">
          <el-pagination
            layout="prev, pager, next"
            :total="customersNew.count"
            :current-page="parseInt(page)"
            @current-change="
            e => {
              toAnotherPage(e, optionView, form.search, valueStatus), settingTable(e, optionView);
            }
          "
            :page-size="parseInt(optionView)"
          ></el-pagination>
        </el-row>
      </el-col>
    </el-row>
    <el-dialog title="Update status customer new" :visible.sync="dialogFormVisible">
      <el-radio-group v-model="payload.status">
        <el-radio label="NEW">NEW</el-radio>
        <el-radio label="ON_PROCESS">ON PROCESS</el-radio>
        <el-radio label="DONE">DONE</el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">Cancel</el-button>
        <el-button type="primary" @click="updateStatus">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { Message } from "element-ui";
import ApiService from "../../common/api.service";
export default {
  data() {
    return {
      dialog: false,
      payload: {
        id: 0,
        status: 'NEW',
        idx: 0
      },
      form: {
        search: ""
      },
      optionsView: [
        {
          value: 1,
          label: "1"
        },
        {
          value: 2,
          label: "2"
        },
        {
          value: 75,
          label: "75"
        },
        {
          value: 100,
          label: "100"
        },
        {
          value: 125,
          label: "125"
        },
        {
          value: 150,
          label: "150"
        }
      ],
      optionView: 25,
      optionsStatus: [
        {
          value: 'done',
          label: "Done"
        },
        {
          value: 'on_progress',
          label: "On Progress"
        },
        {
          value: 'payment_confirmation',
          label: "Menunggu Pembayaran"
        },
        {
          value: 'pending',
          label: "Tertunda"
        },
        {
          value: 'delivery',
          label: "Dalam Pengiriman"
        },
      ],
      valueStatus: 'on_progress',
      page: 1,
      dialogFormVisible: false,
    };
  },
  mounted() { },
  methods: {
    ...mapActions({
      getCustomerNews: "customerNew/GetCustomerNews",
      deleteCustomerNew: "customerNew/DeleteCustomerNew"
    }),
    async updateStatus() {
      try {
        await ApiService.put(
          `/v1/onboard/${this.payload.id}/status/${this.payload.status}`,
        );
        Message({
          message: "Update completed",
          type: "success"
        });
        this.customersNew.data[this.payload.idx].status = this.payload.status
        this.dialogFormVisible = false
      } catch (e) {
        Message({
          message: "Update error",
          type: "error"
        });
      }
    },
    toAnotherPage(page, limit, search) {
      this.$router.push({ path: "/customer-new", query: { page: page, limit: limit, search: search } });
    },
    onSearch() {
      this.$router.replace({ path: "/customer-new", query: { page: 1, limit: 25, search: this.form.search } });
      this.page = this.$router.history.current.query.page;
      this.optionView = this.$router.history.current.query.limit;
      let option = {
        params: {
          page: this.page,
          limit: this.optionView,
          search: this.form.search
        }
      };
      this.getCustomerNews(option);
    },
    settingTable() {
      this.page = this.$router.history.current.query.page;
      this.optionView = this.$router.history.current.query.limit;
      this.form.search = this.$router.history.current.query.search;
      this.valueStatus = this.$router.history.current.query.status;
      let option = {
        params: {
          page: this.page,
          limit: this.optionView,
          search: this.form.search,
        }
      };
      if (this.valueStatus !== '') {
        option = {
          params: {
            ...option.params,
          }
        }
      }
      this.getCustomerNews(option);
    }
  },
  computed: {
    ...mapState({
      customersNew: state => state.customerNew.customersNew
    })
  },
  created() {
    this.page = this.$router.history.current.query.page || 1;
    this.optionView = this.$router.history.current.query.limit || 25;
    this.form.search = this.$router.history.current.query.search || '';
    this.valueStatus = this.$router.history.current.query.status || '';
    let option = {
      params: {
        page: this.page,
        limit: this.optionView,
        search: this.form.search,
      }
    };
    this.getCustomerNews(option);
  }
};
</script>

<style>
.custom-container {
  padding-top: 0px !important;
}
.custom-table thead {
  background-color: #dee2e6;
}
.custom-table thead tr th {
  font-weight: bold;
}
.custom-table tbody {
  background-color: #f8f9fa;
}
</style>
